import { CommonModule } from "@angular/common";
import { Component, computed, inject, signal } from "@angular/core";
import { toSignal } from "@angular/core/rxjs-interop";
import { ActivatedRoute } from "@angular/router";
import { TranslateModule } from "@ngx-translate/core";
import { PulseSurveyService } from "@shared/services/legacy/pulse-survey.service";
import { CollapseComponent } from "../../../shared/components/collapse/collapse.component";

@Component({
	selector: "app-pulse-survey-result",
	imports: [TranslateModule, CommonModule, CollapseComponent],
	templateUrl: "./pulse-survey-result.component.html",
	styleUrl: "./pulse-survey-result.component.scss",
})
export class PulseSurveyResultComponent {
	readonly #route = inject(ActivatedRoute);
	readonly #pulseSurveyService = inject(PulseSurveyService);

	readonly #pulseSurveyId = signal(this.#route.snapshot.params.surveyId);

	readonly pulseSurvey = toSignal(
		this.#pulseSurveyService.getHistoricPulseSurvey(this.#pulseSurveyId()),
	);

	readonly score = computed(() => {
		const survey = this.pulseSurvey();
		if (!survey?.scoring) return null;
		return survey.scoring.find(
			(e: any) =>
				e.startScore <= survey.Value.Value && survey.Value.Value <= e.endScore,
		);
	});

	readonly isUserScore = (startScore: number, endScore: number): boolean => {
		const survey = this.pulseSurvey();
		return survey
			? startScore <= survey.Value.Value && survey.Value.Value <= endScore
			: false;
	};
}
